export default __webpack_public_path__ + "static/media/victoriaadepoju.0c25e532.jpg";